import { render } from "./OfficeInfoText.vue?vue&type=template&id=48131665&scoped=true"
import script from "./OfficeInfoText.vue?vue&type=script&lang=js"
export * from "./OfficeInfoText.vue?vue&type=script&lang=js"

import "./OfficeInfoText.vue?vue&type=style&index=0&id=48131665&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48131665"]])

export default __exports__